import React from 'react';
import { motion } from 'framer-motion';
import { useTranslation } from 'react-i18next';

const CallToAction = () => {
  const { t } = useTranslation();

  return (
    <div className="relative py-48">
      <div 
        className="absolute inset-0 bg-cover bg-center bg-fixed"
        style={{
          backgroundImage: "url('https://res.cloudinary.com/dansvy9a5/image/upload/v1739113189/1736183457870_2_ncurbg.jpg')"
        }}
      >
        <div className="absolute inset-0 bg-gradient-to-b from-black/80 via-black/50 to-black/80" />
      </div>
      
      <motion.div 
        className="relative text-center max-w-4xl mx-auto px-4"
        initial={{ opacity: 0, y: 20 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true }}
        transition={{ duration: 0.8 }}
      >
        <motion.h2 
          className="text-5xl md:text-6xl font-serif mb-8"
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.8, delay: 0.2 }}
        >
          {t('cta.title')}{' '}
          {t('cta.subtitle')}{' '}
          <span className="text-[#c9ab81] italic">{t('cta.highlight')}</span>
          {t('cta.question')}
        </motion.h2>
        
        <motion.p 
          className="text-xl text-gray-300 mb-12 font-light"
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.8, delay: 0.4 }}
        >
          {t('cta.description')}
        </motion.p>

        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.8, delay: 0.6 }}
        >
          <a 
            href="https://docs.google.com/forms/d/e/1FAIpQLSc5mmPDqzUeexziQ_G5pmpiTNH2flL2p6DW5yWL2cu1lWC-6Q/viewform"
            target="_blank"
            rel="noopener noreferrer"
            className="group relative inline-block px-12 py-4 overflow-hidden"
          >
            <div className="absolute inset-0 w-0 bg-[#c9ab81] transition-all duration-[750ms] ease-out group-hover:w-full" />
            <span className="relative text-lg font-serif group-hover:text-black transition-colors duration-[750ms]">
              {t('cta.button')}
            </span>
            <div className="absolute inset-0 border border-[#c9ab81] pointer-events-none" />
          </a>
        </motion.div>

        {/* Decorative Elements */}
        <div className="absolute left-1/2 -translate-x-1/2 bottom-0 w-32 h-px bg-gradient-to-r from-transparent via-[#c9ab81] to-transparent opacity-50" />
      </motion.div>
    </div>
  );
};

export default CallToAction;